import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import CarPark from  '../../Assets/Projects/CarPark.png';
import Evently from   '../../Assets/Projects/Evently.png';
import sih  from '../../Assets/Projects/sih.png'
import portfolio from '../../Assets/Projects/Portfolio.png'
import goGreen from  '../../Assets/Projects/goGreen.png'
import healrai from '../../Assets/Projects/healrai.png'
import krishishakti from '../../Assets/Projects/krishishakti.png'
import trinity from '../../Assets/Projects/trinity.png'

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={krishishakti}
              isBlog={false}
              title="Krishishakti"
              description="Agriculture Website created using Next.js, Typescript, shadcn-ui, mongodb, clerk"            
              ghLink="/project"
              demoLink="https://krishishakti-new.vercel.app/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={healrai}
              isBlog={false}
              title="Healr.ai"
              description="One stop solution for all your health problems, built using NextJs, react, mongodb, postgresql, clerk, shadcn-ui, javascript, vercel, Google GenAI, etc."
              ghLink="/"
              demoLink="https://healrai.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={trinity}
              isBlog={false}
              title="Trinity Middle East LLC Website"
              description="Trinity Middle East LLC Website created using Next.js, mongodb, NextAuth, Google Auth, etc."
              ghLink="/project"
              demoLink="https://trinitymiddleeastllc.com" 
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={CarPark}
              isBlog={false}
              title="Cark Parking Space Project"
              description="Automated Car Parking Space Detection Project Using Image Processing In Python"
              ghLink="https://github.com/KaranGulve4342/Parking-space-project.git"
              // demoLink="https://chatify-49.web.app/"
              demoLink="/project"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Evently}
              isBlog={false}
              title="Event Management Website"
              description="Event Management Website created using Next.js, Typescript, shadcn-ui, mongodb, clerk"
              ghLink="https://github.com/KaranGulve4342/event_management.git"
              demoLink="/"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portfolio}
              isBlog={false}
              title="Portfolio"
              description="Personal Portfolio built using react"
              ghLink="https://github.com/KaranGulve4342/Portfolio_edit.git"
              // demoLink="https://plant49-ai.herokuapp.com/"
              demoLink="https://github.com/KaranGulve4342/Portfolio_edit.git"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
